@if (message) {
<div class="overlay" (click)="cancel()"></div>
}

@if (message) {
<div class="notifications">

  <!-- Dynamic Top Icon Container -->
  <div class="alert-icon-container">
    @if (header && header.toLowerCase().includes('save')) {
    <!-- Floppy/Save Icon Circle -->
    <div class="alert-icon-circle save-type">
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
        <polyline points="17 21 17 13 7 13 7 21"></polyline>
        <polyline points="7 3 7 8 15 8"></polyline>
      </svg>
    </div>
    } @else if (header && header.toLowerCase().includes('leave')) {
    <!-- Orange Warning Icon Circle -->
    <div class="alert-icon-circle warning-type">
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
    </div>
    } @else if (header && (header.toLowerCase().includes('delete') || header.toLowerCase().includes('remove'))) {
    <!-- Red Trash/Delete Icon Circle -->
    <div class="alert-icon-circle delete-type">
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        <line x1="10" y1="11" x2="10" y2="17"></line>
        <line x1="14" y1="11" x2="14" y2="17"></line>
      </svg>
    </div>
    } @else if (type === 'error') {
    <!-- Error Exclamation Icon Circle -->
    <div class="alert-icon-circle error-type">
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </div>
    } @else {
    <!-- Standard Check/Info Icon Circle -->
    <div class="alert-icon-circle success-type">
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
    </div>
    }
  </div>

  <h4 class="heading">{{ header }}</h4>
  <p class="message" [innerHTML]="message"></p>

  @if (!hideButtons) {
    @if (notice) {
    <div class="buttons-row justify-content-center">
      <button class="confirm-btn single-btn" (click)="clearAlert()">
        {{ 'SHARED.COMMON.OK' | translate }}
      </button>
    </div>
    } @else {
    <div class="buttons-row">
      <button class="cancel-btn" (click)="cancel()">
        {{ cancelLabel }}
      </button>
      <button class="confirm-btn" [class.danger-btn]="header && header.toLowerCase().includes('leave')"
        (click)="confirm()" [disabled]="isConfirming">
        @if (isConfirming) {
          <i class="fas fa-spinner fa-spin mr-1"></i>
        }
        {{ confirmLabel }}
      </button>
    </div>
    }
  }
</div>
}